export default __webpack_public_path__ + "static/media/tweeter.b347d52f.jpg";